module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_6000.912d8be1.png";